import * as React from "react";
import classNames from "components/ui/classNames";

export type TextInputHeight = 28 | 32 | 36 | 40 | 44 | 48 | 52;

interface TextInputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  height?: TextInputHeight;
}

export default function TextInput({ height = 32, disabled, className, style, ...props }: TextInputProps) {
  return (
    <input
      spellCheck={false}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      disabled={disabled}
      className={classNames(
        "pointer-events-auto m-0 box-border flex w-full appearance-none",
        "rounded border border-neutral-200 bg-white p-0 px-3 text-sm",
        "transition-all duration-75",
        "placeholder:tracking-wide placeholder:text-slate-500",
        "hover:border-blue-600",
        "focus:border-[#8195ee] focus:shadow-[#d1d9fa_0px_0px_0px_3px] focus:outline-none focus:ring-0",
        "invalid:border-red-500 invalid:shadow-[#d1d9fa_0px_0px_0px_3px] invalid:outline-none invalid:ring-0",
        "disabled:pointer-events-none disabled:bg-gray-100 disabled:text-gray-600",
        className,
      )}
      style={{
        height,
        ...style,
      }}
      {...props}
    />
  );
}
